import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  /** ********************************************selectColumns***************************** */

  const selectColumns = {
    collaborationStateSelectColums: [
      {
        value: 0,
        label: '待合作',
      },
      {
        value: 1,
        label: '合作中',
      },
      {
        value: 2,
        label: '合作取消',
      },
      {
        value: 3,
        label: '合作结束',
      },
    ],
    auditStateSelectColums: [
      {
        value: 0,
        label: '待审核',
      },
      {
        value: 1,
        label: '已通过',
      },
      {
        value: 2,
        label: '已驳回',
      },
    ],
    auditContentSelectColums: [
      {
        value: 0,
        label: '创建合作关系',
      },
      {
        value: 1,
        label: '取消合作关系',
      },
      {
        value: 2,
        label: '合作内容变更',
      },
    ],
  }


  // 服务类型
  const serviceTypes = new Map([
    [0, '车源方'],
    [1, '维修厂'],
    [2, '保险公司'],
  ])

  // 合作状态
  const collaborationStates = new Map([
    [0, '待合作'],
    [1, '合作中'],
    [2, '合作取消'],
    [3, '合作结束'],
  ])

  // 0待审核/1已通过/2已驳回
  const auditStates = new Map([
    [0, '待审核'],
    [1, '已通过'],
    [2, '已驳回'],
  ])

  const auditContents = new Map([
    [0, '创建合作关系'],
    [1, '取消合作关系'],
    [2, '合作内容变更'],
  ])

  const useState = new Map([
    [0, '未使用'],
    [1, '已使用'],
    [2, '待确认'],
  ])

  const maintenanceReviewColumns = [
    {
      name: 'id',
      align: 'center',
      columnProps: {
        label: '合作关系ID',
        prop: 'id',
        minWidth: 120,
      },
      render: ({ row }) => {
        return <span class="a-hover-link" onClick={() => this.openDetailPage(row)}>{row.id}</span>
      },
    },
    {
      name: 'serviceId',
      align: 'center',
      columnProps: {
        label: '服务商ID',
        prop: 'serviceId',
        minWidth: 120,
      },
    },
    {
      name: 'serviceName',
      align: 'center',
      columnProps: {
        label: '服务商名称',
        prop: 'serviceName',
        minWidth: 120,
      },
    },
    {
      name: 'serviceType', // 0车源方 1维修厂 2保险公司
      align: 'center',
      columnProps: {
        label: '服务商类型',
        prop: 'serviceType',
        minWidth: 120,
      },
      getText: ({ row }) => serviceTypes.get(row.serviceType),
    },
    {
      name: 'createTime',
      align: 'center',
      columnProps: {
        label: '创建时间',
        prop: 'createTime',
        minWidth: 120,
      },
    },
    {
      name: 'collaborationState', // 0待合作/1合作中/2合作取消/3合作结束
      align: 'center',
      columnProps: {
        label: '合作状态',
        prop: 'collaborationState',
        minWidth: 120,
      },
      getText: ({ row }) => collaborationStates.get(row.collaborationState),
    },
    {
      name: 'auditState', // 0待审核/1已通过/2已驳回
      align: 'center',
      columnProps: {
        label: '审核状态',
        prop: 'auditState',
        minWidth: 120,
      },
      getText: ({ row }) => auditStates.get(row.auditState),
    },

    {
      name: 'auditContent', // 0:创建合作关系 1:取消合作关系
      align: 'center',
      columnProps: {
        label: '最新审核内容',
        minWidth: 180,
        prop: 'auditContent',
      },
      getText: ({ row }) => auditContents.get(row.auditContent),
    },
  ]

  const maintenanceReviewDetailcolumn = [
    {
      key: 'name',
      name: '服务商名称',
    },
    {
      key: 'serviceType',
      name: '服务商类型',
    },
    {
      key: 'contacts',
      name: '联系人',
    },
    {
      key: 'contactTel',
      name: '联系人电话',
    },
    {
      key: 'creditCode',
      name: '统一社会信用代码',
    },
    {
      key: 'accountName',
      name: '账户名称',
    },
    {
      key: 'accountNo',
      name: '开户账号',
    },
    {
      key: 'bankName',
      name: '开户银行',
    },
    {
      key: 'gmtCreate',
      name: '创建时间',
    },
    {
      key: 'address',
      name: '客户地址',
    },
  ]

  const maintenanceReviewdetailExamineInfo = [
    {
      key: 'auditState',
      name: '审核状态',
    },
    {
      key: 'auditTime',
      name: '审核时间',
    },
    {
      key: 'auditRejectReason',
      name: '驳回原因',
    },
  ]
  this.$nextTick(() => {
    maintenanceReviewColumns.push(
      {
        name: 'operate',
        align: 'center',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        render: ({ row }) => {
          const btns = []
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.openStoreListDialog(row)
                },
              },
            }, '门店列表'),
          )


          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.openProjectListDialog(row)
                },
              },
            }, '项目列表'),
          )

          return btns
        },
      },
    )
  })


  const storeListDialogText = {
    text: '提示:此处展示的门店为服务商提供的所有门店,',
    mark: '实际维修保养项目可使用的门店以项目中可使用的门店为准',
  }
  return {
    maintenanceReviewColumns,
    maintenanceReviewDetailcolumn,
    maintenanceReviewdetailExamineInfo,
    storeListDialogText,
    selectColumns,
    serviceTypes,
    auditStates,
    useState,
  }
}
